const DownloadEarn = () => import(/* webpackChunkName: "chunk-download" */ '../views/P5_Download/DownloadEarn/index.vue')
const Download = () => import(/* webpackChunkName: "chunk-download" */ '../views/P5_Download/Download/index.vue')
const DownloadAgent = () => import(/* webpackChunkName: "chunk-download" */ '../views/P5_Download/DownloadAgent/index.vue')

// prettier-ignore
const Routes = [
  {
    path: '/download', alias: '/echo-download', name: 'download', component: Download, 
  },
  {
    path: '/download-agent', name: 'download-agent', component: DownloadAgent
  },
  {
    path: '/download-earn', name: 'download-earn', component: DownloadEarn
  }
]
export default Routes
